import { useEffect, useMemo, useState } from 'react';
import { scrollToTop } from '../../../library/helpers/scroll-to-top';
import { StepperConnector } from './stepper.models';
import { useSearchParams } from 'react-router';

const STEP_NUMBER = 'stepNumber';

// TODO: next(), previous() and goTo() don't have context of disabled steps
export function useStepperConnector(): StepperConnector {
  const [searchParams, setSearchParams] = useSearchParams();

  function setStepNumberSearchParam(stepNumber: number) {
    setSearchParams({ [STEP_NUMBER]: stepNumber.toString() }, { replace: true });
  }

  useEffect(() => {
    const stepNumberSearchParam = searchParams.get(STEP_NUMBER);
    if (!stepNumberSearchParam) setStepNumberSearchParam(1);
  }, []);

  const activeStepNumber = useMemo(() => {
    const stepNumberSearchParam = searchParams.get(STEP_NUMBER);
    return !stepNumberSearchParam ? 1 : parseInt(stepNumberSearchParam);
  }, [searchParams.get(STEP_NUMBER)]);

  const [stepCount, setStepCount] = useState<number>(0);

  useEffect(scrollToTop, [activeStepNumber]);

  return {
    setStepCount,
    activeStepNumber,
    previous: () => {
      if (activeStepNumber === 1) return;
      setStepNumberSearchParam(activeStepNumber - 1);
    },
    next: () => {
      if (activeStepNumber === stepCount) return;
      setStepNumberSearchParam(activeStepNumber + 1);
    },
    goTo: (stepNumber: number) => {
      if (stepNumber === activeStepNumber || stepNumber < 1 || stepNumber > stepCount) return;
      setStepNumberSearchParam(stepNumber);
    },
  };
}
